<template>
  <div>
    Sorry, page not found.
    <br>
    <router-link :to="{ name: 'home' }">
      Home
    </router-link>
  </div>
</template>
